import { useContext } from 'react'

import { computeDiscountValue, numberToBRL } from '~/modules/sales/services'

import { discountFormContext } from '.'
import { subscriptionsCheckoutContext } from '../..'

function formatCyclesMessage(cycles: number) {
  return cycles > 1 ? `as próximas ${cycles} cobranças` : 'esta compra'
}

export const CartArea: React.FC = () => {
  const { plan } = useContext(subscriptionsCheckoutContext)
  const { coupon } = useContext(discountFormContext)

  return (
    <>
      <div className=' flex flex-col pb-2 gap-8 border-b border-slate-300'>
        {plan?.metaData.items.length ? (
          plan.metaData.items.map((item, index) => (
            <div
              key={`checkout-item-${index + 1}`}
              className='flex flex-1  justify-between'
            >
              <p>{item.name}</p>
              <p>{numberToBRL(item.pricing_scheme.price / 100)}</p>
            </div>
          ))
        ) : (
          <div className='flex flex-1  justify-between'>
            <p>Sem items</p>
            <p>R$ xxx,xx</p>
          </div>
        )}

        {coupon ? (
          <div
            className='flex flex-col py-1 px-2 gap-1 bg-white/40 rounded-md
            border-2 border-gpa-blue-400/50'
          >
            <h3 className='font-semibold'>Desconto:</h3>
            <div className='flex justify-between'>
              <p>{coupon?.code} aplicado</p>
              <p>
                -
                {numberToBRL(
                  computeDiscountValue(
                    coupon?.type,
                    coupon?.value,
                    plan?.value ?? 0,
                  ) / 100,
                )}
              </p>
            </div>
            <p className='text-sm'>
              Este desconto vale para {formatCyclesMessage(coupon?.cycles)}
            </p>
          </div>
        ) : null}

        <div className='flex flex-1 justify-between'>
          <p className='font-bold'>Total</p>
          <p>
            {numberToBRL(
              ((plan?.value ?? 0) -
                (coupon
                  ? computeDiscountValue(
                      coupon?.type,
                      coupon?.value,
                      plan?.value ?? 0,
                    )
                  : 0)) /
                100,
            )}
          </p>
        </div>
      </div>
    </>
  )
}
